export const SERVER_NAMES = {
  auth0: "auth0",
  askrShifts: "askrShifts",
  askrSegments: "askrSegments",
  askrCurrentSegment: "askrCurrentSegment",
  askrAggregates: "askrAggregates",
  midgardDataDumpsTrendChart: "midgardDataDumpsTrendChart",
  midgardDataDumpsTrendChartCounts: "midgardDataDumpsTrendChartCounts",
  midgardDataDumpFullRange: "midgardDataDumpFullRange",
  midgardDataDumpHubletView: "midgardDataDumpHubletView",
  midgardDataDumpOverriddenMetrics: "midgardDataDumpOverriddenMetrics",
  midgardLastDataDumpRow: "midgardLastDataDumpRow",
  midgardLastDataDumpRowPerProcess: "midgardLastDataDumpRowPerProcess",
  midgardDataDumpsPnlLossesByUnit: "midgardDataDumpsPnlLossesByUnit",
  midgardDataDumpSinceLotStart: "midgardDataDumpSinceLotStart",
  midgardDataDumpRollingWindow: "midgardDataDumpRollingWindow",
  midgardDataDumpsGroupTiles: "midgardDataDumpsGroupTiles",
  midgardDataDumpsFullRangeByProcess: "midgardDataDumpsFullRangeByProcess",
  midgardDataDumpFullRangeSubordinateProcesses:
    "midgardDataDumpFullRangeSubordinateProcesses",
  midgardSku: "midgardSku",
  midgardLotInfo: "midgardLotInfo",
  midgardLotCounts: "midgardLotCounts",
  midgardDataDumpRows: "midgardDataDumpRows",
  supervisorAllocation: "supervisorAllocation",
  launchDarkly: "launchDarkly",
  midgardProcessGroups: "midgardProcessGroups",
  midgardCustomerInfo: "midgardCustomerInfo",
  midgardWorkSchedules: "midgardWorkSchedules",
} as const; // "as const" here lets us use `keyof typeof SEVER_NAMES` as a type elsewhere

export type ServerNameEnum = keyof typeof SERVER_NAMES;
